import { useFlags } from "launchdarkly-react-client-sdk";

import { useListSyncsQuery } from "@/apollo/types";
import SyncsTable from "@/pages/ReverseEltSyncs/modules/SyncsTable";

import MainTabsLayout from "./MainTabsLayout";
import { RevEltSyncsEmptyState } from "./modules/RevEltSyncsEmptyState";
import CreateSyncPage from "./new/CreateSyncPage";

export default function ReverseEltSyncsPage() {
  const { data, loading } = useListSyncsQuery();

  const { newReverseEtlSetupExperience } = useFlags();

  if (loading) {
    return <div />;
  }

  if (newReverseEtlSetupExperience && data?.syncs.length === 0) {
    return <CreateSyncPage pageTitle="Create Your First Reverse ETL Sync" />;
  }

  return (
    <MainTabsLayout>
      {data?.syncs.length === 0 ? (
        <RevEltSyncsEmptyState />
      ) : (
        <SyncsTable syncs={data?.syncs ?? []} />
      )}
    </MainTabsLayout>
  );
}
